import { render, staticRenderFns } from "./SubscribeToProjectModal.vue?vue&type=template&id=612aa18e"
import script from "./SubscribeToProjectModal.vue?vue&type=script&lang=js"
export * from "./SubscribeToProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports